
import { Vue, Component } from 'vue-property-decorator'
import { apiSettingsImgtoolGetList, apiSettingsImgtoolVersion, apiSettingsImgtoolSetParam } from '@/api/setting'
@Component({
    components: {}
})
export default class ImgTool extends Vue {
    /** S Data **/
    version = ''
    list = []
    dialogVisible = false
    form: any = {
        param: {
            shop_sn: '',
            target_id: '',
            target_type: ''
        },
        versions: '',
        name: ''
    }
    targetTypeList = [
        {
            label: '商户后台设计',
            value: '1'
        },
        {
            label: '用户设计',
            value: '2'
        },
        {
            label: '用户设计合成',
            value: '3'
        },
        {
            label: '生产图',
            value: '4'
        },
        {
            label: '规格图片',
            value: '5'
        },
    ]
    /** E Data **/

    /** S Methods **/

    // 获取存储引擎列表
    getList() {
        apiSettingsImgtoolGetList({ page_size: 99 })
            .then((res: any) => {
                this.list = res.lists
            })
            .catch(() => {
                this.$message.error('获取数据失败，请重试！')
            })
    }
    // 编辑
    edit(item: any) {
        this.form = { ...item }
        this.dialogVisible = true
    }
    // 保存
    save() {
        apiSettingsImgtoolSetParam(this.form)
            .then((res: any) => {
                this.getList()
                this.dialogVisible = false
            })
            .catch(() => {
                this.$message.error('保存失败，请重试！')
            })
    }
    // 更新版本
    updateVersion() {
        apiSettingsImgtoolVersion({ version: this.version })
            .then((res: any) => {
                this.$message.success('更新成功')
                this.getList()
            })
            .catch(() => {
                this.$message.error('更新失败，请重试！')
            })
    }

    /** E Methods **/

    /** S Life Cycle **/
    created() {
        this.getList()
    }
    /** E Life Cycle **/
}
